import { connect } from 'react-redux';
import { enterZoomMode, exitZoomMode } from '../DeviationPage/redux/actions';
import { getIsZoomed } from '../DeviationPage/redux/selectors';
import { getIsCurrentUserAuthorOf } from '../redux/deviations/selectors';
const mapStateToProps = (state, { deviation })=>({
        isZoomed: getIsZoomed(state),
        isOwner: getIsCurrentUserAuthorOf(state, deviation)
    });
const mapDispatchToProps = {
    onEnterZoomMode: enterZoomMode,
    onExitZoomMode: exitZoomMode
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=ArtStage.container.js.map